module.exports = __webpack_public_path__ + "img/history-empty.8c17ecde.png";